import {
    optionsSearchBox_placeholder,
    optionsSpamSearchBox_empty,
    optionsSpam_placeholderEmpty,
} from './SpamOptionFull.locstring.json';
import { options_common_addButtonLabel } from 'owa-locstrings/lib/strings/options_common_addbuttonlabel.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import SpamOptionRow from '../components/SpamOptionRow';
import { SpamScenarioId } from 'owa-junkmail-configuration';

import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { createNewSpamItem } from '../actions/spamNewItemMutatorActions';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getMailboxJunkEmailListByScenarioId } from 'owa-junkmail-configuration';
import { getSpamDescription, getSpamPlaceHolder } from '../utils/getSpamStrings';
import { observer } from 'mobx-react';
import { OptionDescription } from 'owa-options-controls';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { setSearchQuery } from '../actions/spamSearchQueryMutatorActions';
import { SpamScenarioStore } from '../store/schema/SpamOptionStore';

const styles = require('./SpamOptionFull.scss');
const classNames = require('classnames/bind').bind(styles);

export interface SpamOptionFullProps {
    scenarioId: SpamScenarioId;
}

@observer
export default class SpamOptionFull extends React.Component<SpamOptionFullProps, {}> {
    render() {
        const optionState = getSpamScenarioStore(this.props.scenarioId);
        const spamRowsToRender = this.getSpamRowsToRender(optionState);
        const hasRowsToRender = spamRowsToRender.length > 0;
        return (
            <>
                <OptionDescription>{getSpamDescription(this.props.scenarioId)}</OptionDescription>
                <div className={styles.optionHeader}>
                    <ActionButton
                        className={styles.createSpamRowNameButton}
                        onClick={this.onCreateNewSpamRow}
                        text={loc(options_common_addButtonLabel)}
                        iconProps={{
                            iconName: ControlIcons.Add,
                            styles: {
                                root: classNames(styles.icon),
                            },
                        }}
                    />
                    <SearchBox
                        value={optionState.searchQuery}
                        onChange={this.filterResults}
                        placeholder={loc(optionsSearchBox_placeholder)}
                        styles={{ root: styles.spamSearchBox }}
                    />
                </div>
                <div className={styles.spamScrollContainer}>
                    {hasRowsToRender
                        ? spamRowsToRender
                        : this.emptyListText(optionState.searchQuery)}
                </div>
            </>
        );
    }

    private filterResults = (event: React.ChangeEvent<HTMLInputElement>, searchQuery: string) => {
        setSearchQuery(this.props.scenarioId, searchQuery);
    };

    private emptyListText = (searchQuery: string): JSX.Element => {
        return (
            <div className={styles.emptyState}>
                {searchQuery ? loc(optionsSpamSearchBox_empty) : loc(optionsSpam_placeholderEmpty)}
            </div>
        );
    };

    private onCreateNewSpamRow = () => {
        createNewSpamItem(this.props.scenarioId);
    };

    private getSpamRowsToRender(optionState: SpamScenarioStore): JSX.Element[] {
        const placeHolder = getSpamPlaceHolder(this.props.scenarioId);
        const newSpamRowName = optionState.newSpamItem;

        // This textfield is generated only if user is adding a new row.
        // Index is set to -1 to indicate we are not modifying an existing row.
        const spamRowsToRender: JSX.Element[] = [];
        if (newSpamRowName !== null) {
            spamRowsToRender.push(
                <SpamOptionRow
                    scenarioId={this.props.scenarioId}
                    key={newSpamRowName}
                    rowTextValue={newSpamRowName}
                    isEditMode={true}
                    placeHolder={placeHolder}
                    index={-1}
                />
            );
        }

        const spamRows = getFallbackValueIfNull(
            optionState.spamList,
            getMailboxJunkEmailListByScenarioId(this.props.scenarioId)
        );
        const searchQuery = optionState.searchQuery ? optionState.searchQuery.toLowerCase() : null;
        for (let i = 0; i < spamRows.length; i++) {
            const spamRowName = spamRows[i];
            const spamRowNameLC = spamRowName.toLowerCase();
            // If there is no search term or the current spamRowName is a subset of
            // searchQuery, show result.
            if (!searchQuery || spamRowNameLC.indexOf(searchQuery) >= 0) {
                spamRowsToRender.push(
                    <SpamOptionRow
                        scenarioId={this.props.scenarioId}
                        key={spamRowName}
                        rowTextValue={spamRowName}
                        isEditMode={i === optionState.indexToEdit}
                        placeHolder={placeHolder}
                        index={i}
                    />
                );
            }
        }
        return spamRowsToRender;
    }
}
